import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';
import Button from 'app/components/Button/Button';
import { startDirection } from 'app/styles/selectors/markup';
import ButtonsGroup from 'app/components/Button/ButtonsGroup.styled';

const { widthSmall, widthMedium } = breakpoints;
const S = {};

S.HeroBlock = styled.article`
  label: HeroBlock;

  display: flex;

  @media (${widthSmall}) {
    align-items: center;
    flex-direction: column-reverse;
  }

  @media (${widthMedium}) {
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: row;
  }
`;

S.HeroBlock.Content = styled.div`
  label: Content;

  display: flex;
  flex-direction: column;
  flex: 1 1 50%;
  text-align: center;
  padding-top: 2rem;

  @media (${widthSmall}) {
    align-items: center;
    padding-top: 2.5rem;
  }

  @media (${widthMedium}) {
    align-items: flex-start;
    max-width: 38.75rem;
    min-width: 50%;
    padding-top: 4rem;
    text-align: initial;
  }
`;

S.HeroBlock.Content.Title = styled.h1`
  label: Title;

  margin-bottom: 1rem;
`;

S.HeroBlock.Content.Title.Linebreak = styled.br`
  label: TitleLinebreak;

  display: none;

  @media (${widthMedium}) {
    display: block;
  }
`;

S.HeroBlock.Content.Subtitle = styled.h2`
  label: Subtitle;

  margin-bottom: 1.5rem;

  @media (${widthSmall}) {
    margin-bottom: 2rem;
  }

  @media (${widthMedium}) {
    margin-bottom: 2.5rem;
  }
`;

S.HeroBlock.Content.Subtitle.Linebreak = styled.div`
  label: SubtitleLinebreak;

  padding-top: 0.75rem;
`;

S.HeroBlock.ButtonHolder = styled(ButtonsGroup)`
  label: ButtonHolder;

  @media (${widthMedium}) {
    align-self: flex-start;
  }
`;

S.HeroBlock.Button = styled(Button)`
  margin-bottom: 0.75rem;
`;

S.HeroBlock.ImageHolder = styled.div`
  label: ImageHolder;

  flex: 1 1 50%;

  display: none;

  @media (${widthSmall}) {
    display: flex;
    justify-content: flex-end;
  }

  @media (${widthMedium}) {
    padding-${startDirection}: 2rem;
  }
`;

S.HeroBlock.Image = styled.img`
  label: Image;

  object-fit: contain;
  max-width: 100%;

  @media (${widthSmall}) {
    height: 17rem;
  }

  @media (${widthMedium}) {
    height: 25rem;
  }
`;

export default S;
